(function () {
    'use strict';

    angular.module("imApp").factory("operationFactoriesService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 2037,
                    parameters: parms || {}
                });
            },
            listOperationFactories: function (parms) {
                return $ihttp.post({
                    method: 2036,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
